

<template>
  <div>
    <!--    Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--    Contact Information Section Component-->
    <contact-area/>
    <!--    Contact Form Section Component-->
    <contact-form/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import ContactArea from "../components/ContactArea";
import ContactForm from "../components/ContactForm";

export default {
  name: 'Contact',
  components: {ContactForm, ContactArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'Contact Us',
        link: 'Contact'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Contact.vue